import React from 'react'
import Tittle from '../Components/Tittle'
import emailjs from "emailjs-com"
import "./ContactPage.scss"
import Particles from "react-particles-js";
function ContactPage() {

    function sendemail(e) {
        e.preventDefault();
        
        emailjs.sendForm("service_82h3ofd", "template_gaf9y27", e.target, "user_sHEpAxV7QYdtle179ChI5").then(res=>{console.log("successful")
      }).catch(err=>{console.log(err)});
     alert("Email has been sent!!");
    }
  

    return (

        <div className="contact" onSubmit={sendemail}>
        
            <Tittle title={'CONTACT ME'} span={'CONTACT'}/>
            <div>
                <form className="namebox">
                    <label className="fontname" >Name</label>
                    <input type="text" name="name" placeholder="Your name.." required/>
                    <label className="fontname">Email</label>
                    <input type="email" name="user_email" placeholder="Your email" required/>

                    <label className="fontname">Message</label>
                    <textarea
                        name="message"
                        rows="6"
                        placeholder="Write something.."
                        required></textarea>
                    <input type="submit" value="Send"/>
                </form>
            </div>
        </div>
    )
}

export default ContactPage;
